import { gql } from "@apollo/client";

export const GET_PLATFORM_EVENT_LOGS = gql`
  query platformEventLogs(
    $service: EventLogService
    $first: Int
    $after: String
  ) {
    platformEventLogs(service: $service, first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          eventType
          service
          dataType
          occurredAt
          actor {
            id
            firstName
            lastName
            email
          }
          eventData
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;
